// extracted by mini-css-extract-plugin
export default {"shimmer_container":"dashboardCardShimmer_shimmer_container__Tqpy0","icon":"dashboardCardShimmer_icon__BV5w5"};